import { render, staticRenderFns } from "./KYCverif.vue?vue&type=template&id=6d81d093&"
import script from "./KYCverif.vue?vue&type=script&lang=js&"
export * from "./KYCverif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports